(function () {
  'use strict';

  class KoraEngravingDrawer {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      this.config = this._loadConfig();
      this.variantId = null;
      this.quantity = 1;

      this.overlay = el.querySelector('[data-engraving-overlay]');
      this.closeBtn = el.querySelector('[data-engraving-close]');
      this.subtitle = el.querySelector('[data-engraving-subtitle]');
      this.examplesWrap = el.querySelector('[data-engraving-examples]');
      this.pillsWrap = el.querySelector('[data-examples-pills]');
      this.cardsWrap = el.querySelector('[data-engraving-cards]');
      this.confirmBtn = el.querySelector('[data-engraving-confirm]');

      this._renderExamples();
      this._bind();
    }

    _loadConfig() {
      try {
        const el = document.getElementById('kora-engraving-data-' + this.sectionId);
        return el ? JSON.parse(el.textContent) : {};
      } catch (e) {
        return {};
      }
    }

    _renderExamples() {
      const examples = this.config.examples;
      if (!examples || !examples.length || !this.pillsWrap) return;

      this.pillsWrap.innerHTML = examples.map(function (ex) {
        var note = ex.note ? '<span style="font-size:11px;opacity:.55;margin-left:4px">' + ex.note + '</span>' : '';
        return '<button type="button" class="kora-engraving-drawer__example-pill" data-example="' +
          _esc(ex.label) + '">' + _esc(ex.label) + note + '</button>';
      }).join('');

      if (this.examplesWrap) this.examplesWrap.style.display = '';

      this.pillsWrap.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-example]');
        if (pill) this._fillExample(pill.dataset.example);
      }.bind(this));
    }

    _bind() {
      if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.confirmBtn) this.confirmBtn.addEventListener('click', this._handleConfirm.bind(this));

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && this._isOpen()) this.close();
      }.bind(this));
    }

    open(variantId, quantity, optionString) {
      this.variantId = variantId;
      this.quantity = quantity || 1;
      this._updateSubtitle();
      this._renderCards(optionString || '');

      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        var first = this.cardsWrap && this.cardsWrap.querySelector('input');
        if (first) first.focus();
      }.bind(this));
    }

    close() {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    _isOpen() {
      return this.el.classList.contains('is-open');
    }

    _updateSubtitle() {
      if (!this.subtitle) return;
      var cfg = this.config;
      var sides = parseInt(cfg.sides, 10) || 1;
      var max = parseInt(cfg.maxChars, 10) || 4;
      var parts = ['刻字建議 3–' + max + ' 字內'];
      if (sides === 2) parts.push('可加刻背面');
      this.subtitle.textContent = parts.join(' · ');
    }

    _cardsConfig(opt) {
      if (/男.*x2/i.test(opt) || /男.*2/.test(opt)) {
        return [{ g: 'male', label: '男款 1' }, { g: 'male', label: '男款 2' }];
      }
      if (/女.*x2/i.test(opt) || /女.*2/.test(opt)) {
        return [{ g: 'female', label: '女款 1' }, { g: 'female', label: '女款 2' }];
      }
      if (/情侶|對裝/.test(opt)) {
        return [{ g: 'male', label: '男款' }, { g: 'female', label: '女款' }];
      }
      if (/男/.test(opt)) return [{ g: 'male', label: '男款' }];
      if (/女/.test(opt)) return [{ g: 'female', label: '女款' }];
      return [{ g: 'neutral', label: '刻字' }];
    }

    _renderCards(opt) {
      if (!this.cardsWrap) return;
      var cfg = this.config;
      var sides = parseInt(cfg.sides, 10) || 1;
      var max = parseInt(cfg.maxChars, 10) || 4;
      var placeholder = '如：D♥H · 縮寫 · 暱稱';
      var cards = this._cardsConfig(opt);

      this.cardsWrap.innerHTML = cards.map(function (card, i) {
        var id = this.sectionId + '-c' + i;
        var pillClass = card.g === 'female' ? 'kora-engraving-card__pill--female'
          : card.g === 'male' ? 'kora-engraving-card__pill--male'
          : 'kora-engraving-card__pill--neutral';

        var backHTML = '';
        if (sides === 2) {
          backHTML = [
            '<button type="button" class="kora-engraving-card__back-toggle" data-back-toggle="' + id + '">+ 加入背面刻字</button>',
            '<div class="kora-engraving-card__back-section" data-back-section="' + id + '">',
            '  <div class="kora-engraving-card__row">',
            '    <span class="kora-engraving-card__label">背面</span>',
            '    <span class="kora-engraving-card__counter" data-counter="' + id + '-back">0 / ' + max + '</span>',
            '  </div>',
            '  <input class="kora-engraving-card__input" type="text" placeholder="' + placeholder + '"',
            '    data-field="' + id + '-back" data-max="' + max + '" autocomplete="off" maxlength="' + (max + 5) + '">',
            '  <button type="button" class="kora-engraving-card__remove-back" data-back-remove="' + id + '">移除背面</button>',
            '</div>'
          ].join('');
        }

        return [
          '<div class="kora-engraving-card" data-card="' + id + '" data-label="' + _esc(card.label) + '">',
          '  <span class="kora-engraving-card__pill ' + pillClass + '">' + _esc(card.label) + '</span>',
          '  <div class="kora-engraving-card__input-group">',
          '    <div class="kora-engraving-card__row">',
          sides === 2 ? '      <span class="kora-engraving-card__label">正面</span>' : '',
          '      <span class="kora-engraving-card__counter" data-counter="' + id + '-front">0 / ' + max + '</span>',
          '    </div>',
          '    <input class="kora-engraving-card__input" type="text" placeholder="' + placeholder + '"',
          '      data-field="' + id + '-front" data-max="' + max + '" autocomplete="off" maxlength="' + (max + 5) + '">',
          '  </div>',
          backHTML,
          '</div>'
        ].join('');
      }.bind(this)).join('');

      this._bindCardEvents();
    }

    _bindCardEvents() {
      var wrap = this.cardsWrap;
      if (!wrap) return;

      wrap.querySelectorAll('[data-field]').forEach(function (input) {
        var fid = input.dataset.field;
        var max = parseInt(input.dataset.max, 10);
        input.addEventListener('input', function () {
          var len = Array.from(input.value).length;
          var counter = wrap.querySelector('[data-counter="' + fid + '"]');
          if (counter) {
            counter.textContent = len + ' / ' + max;
            counter.classList.toggle('is-over', len > max);
          }
          input.classList.toggle('is-error', len > max);
        });
      });

      wrap.querySelectorAll('[data-back-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.backToggle;
          var sec = wrap.querySelector('[data-back-section="' + id + '"]');
          if (sec) sec.classList.add('is-open');
          btn.style.display = 'none';
        });
      });

      wrap.querySelectorAll('[data-back-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.backRemove;
          var sec = wrap.querySelector('[data-back-section="' + id + '"]');
          var toggle = wrap.querySelector('[data-back-toggle="' + id + '"]');
          var input = sec && sec.querySelector('[data-field]');
          if (input) { input.value = ''; input.dispatchEvent(new Event('input')); }
          if (sec) sec.classList.remove('is-open');
          if (toggle) toggle.style.display = '';
        });
      });
    }

    _fillExample(value) {
      if (!this.cardsWrap) return;
      var inputs = this.cardsWrap.querySelectorAll('[data-field$="-front"]');
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].value) {
          inputs[i].value = value;
          inputs[i].dispatchEvent(new Event('input'));
          inputs[i].focus();
          break;
        }
      }
    }

    _properties() {
      var props = {};
      if (!this.cardsWrap) return props;
      this.cardsWrap.querySelectorAll('[data-card]').forEach(function (card) {
        var label = card.dataset.label;
        var front = card.querySelector('[data-field$="-front"]');
        var back = card.querySelector('[data-field$="-back"]');
        if (front && front.value.trim()) props[label + '正面'] = front.value.trim();
        if (back && back.value.trim()) props[label + '背面'] = back.value.trim();
      });
      return props;
    }

    _hasError() {
      return !!(this.cardsWrap && this.cardsWrap.querySelector('.is-error'));
    }

    _handleConfirm() {
      if (this._hasError()) return;

      var btn = this.confirmBtn;
      var self = this;
      btn.disabled = true;
      btn.textContent = '處理中…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: this.quantity,
          properties: this._properties()
        })
      })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Error'); });
          return res.json();
        })
        .then(function() {
          btn.textContent = '已加入購物車 ✓';
          setTimeout(function() {
            self.close();
            setTimeout(function() {
              _refreshCart();
            }, 350);
          }, 800);
        })
        .catch(function (err) {
          console.error('KORA engraving:', err);
          btn.textContent = '加入失敗，請重試';
          btn.disabled = false;
        })
        .finally(function () {
          setTimeout(function () {
            if (btn.disabled) {
              btn.disabled = false;
              btn.textContent = '確認並加入購物車';
            }
          }, 3000);
        });
    }
  }

  // Detect Broadcast's cart-drawer section ID(s) for the sections API
  function _broadcastSectionIds() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var sid = (drawer.dataset.sectionId || drawer.dataset.id) || null;
      if (sid) {
        ids.push(sid);
      } else {
        var wrap = drawer.closest('[id^="shopify-section-"]');
        if (wrap) ids.push(wrap.id.replace('shopify-section-', ''));
      }
    }
    if (!ids.length) ids.push('cart-drawer');
    return ids;
  }

  function _refreshCart() {
    var sids = _broadcastSectionIds();

    fetch('/?sections=' + sids.join(','))
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        _injectSections(sections, sids);
        setTimeout(_openCart, 200);
      })
      .catch(function() {
        _openCart();
      });
  }

  function _injectSections(sections, sids) {
    sids.forEach(function(sid) {
      var html = sections[sid];
      if (!html) return;

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newSection = doc.getElementById('shopify-section-' + sid) || doc.body.firstElementChild;
      if (!newSection) return;

      // Replace section wrapper innerHTML — triggers cart-drawer disconnectedCallback + connectedCallback
      var wrapper = document.getElementById('shopify-section-' + sid);
      if (wrapper) {
        wrapper.innerHTML = newSection.innerHTML;
        return;
      }

      // Fallback: replace cart-drawer innerHTML
      var newDrawerEl = newSection.querySelector('cart-drawer');
      var curDrawerEl = document.querySelector('cart-drawer');
      if (newDrawerEl && curDrawerEl) {
        curDrawerEl.innerHTML = newDrawerEl.innerHTML;
      }
    });
  }

  function _openCart() {
    // 1. Try calling open() directly on the cart-drawer custom element
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer) {
      var cartAlreadyOpen = drawer.classList.contains('is-open') ||
                            drawer.getAttribute('aria-hidden') === 'false' ||
                            drawer.classList.contains('is-active');
      if (!cartAlreadyOpen) {
        if (typeof drawer.open === 'function') { drawer.open(); return; }
        if (typeof drawer.show === 'function') { drawer.show(); return; }
      } else {
        return; // already open — nothing to do
      }
    }

    // 2. Click the cart toggle button (reliable across all Broadcast versions)
    var toggle =
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('[data-js-cart-toggle]') ||
      document.querySelector('button.cart-toggle') ||
      document.querySelector('a[href="/cart"].header__icon');

    if (toggle) {
      var alreadyOpen = toggle.getAttribute('aria-expanded') === 'true' ||
                        (drawer && drawer.classList.contains('is-open'));
      if (!alreadyOpen) { toggle.click(); return; }
    }

    // 3. Last-resort events
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    window.dispatchEvent(new CustomEvent('cart:open'));
  }

  function _esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Get option string from variant config by variant ID
  function _getOptionStringById(vid, drawerEl) {
    if (!drawerEl || !drawerEl._koraDrawer) return '';
    var cfg = drawerEl._koraDrawer.config;
    if (!cfg.variants || !vid) return '';
    var variant = cfg.variants.find(function (v) { return v.id === vid; });
    return variant ? (variant.options || []).join(' ') : '';
  }

  // Keep button text in sync: "加入購物車及設計" for engraving variants, normal text for 不刻字
  function _watchButtonText(btn, drawerEl, sectionId) {
    var textSpan = btn.querySelector('[data-add-to-cart-text]');
    if (!textSpan) return;

    function getCurrentOpt() {
      var formEl = btn.closest('product-form') || document.querySelector('product-form[data-section-id="' + sectionId + '"]');
      var form = formEl && formEl.querySelector('form');
      var idInput = form && form.querySelector('[name="id"]');
      var vid = idInput ? parseInt(idInput.value, 10) : null;
      return _getOptionStringById(vid, drawerEl);
    }

    function fix() {
      if (btn.disabled) return;
      var noEngraving = /不刻字/.test(getCurrentOpt());
      for (var i = 0; i < textSpan.childNodes.length; i++) {
        var n = textSpan.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) {
          if (noEngraving) {
            if (n.textContent.includes('設計')) n.textContent = '加入購物車';
          } else {
            if (!n.textContent.includes('設計')) n.textContent = '加入購物車及設計';
          }
          break;
        }
      }
    }

    new MutationObserver(fix).observe(textSpan, { childList: true, characterData: true, subtree: true });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { if (m.attributeName === 'disabled') fix(); });
    }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    requestAnimationFrame(fix);
  }

  function initDrawers() {
    document.querySelectorAll('[data-engraving-drawer]').forEach(function (el) {
      if (!el._koraDrawer) el._koraDrawer = new KoraEngravingDrawer(el);
    });
  }

  // Intercept button click (capture phase = runs before Broadcast's handlers)
  function initFormIntercept() {
    document.querySelectorAll('[data-engraving-drawer]').forEach(function (drawerEl) {
      var sectionId = drawerEl.dataset.sectionId;
      var btn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!btn || btn._koraIntercepted) return;
      btn._koraIntercepted = true;

      btn.addEventListener('click', function (e) {
        if (btn.disabled) return; // sold-out — let Broadcast show its error normally

        var productFormEl = btn.closest('product-form') || document.querySelector('product-form[data-section-id="' + sectionId + '"]');
        var form = productFormEl && productFormEl.querySelector('form');
        var idInput = form && form.querySelector('[name="id"]');
        var qtyInput = form && form.querySelector('[name="quantity"]');

        var vid = idInput ? parseInt(idInput.value, 10) : null;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var opt = _getOptionStringById(vid, drawerEl);

        if (/不刻字/.test(opt)) return; // 不刻字 variants: skip drawer, let normal add-to-cart proceed

        e.preventDefault();
        e.stopImmediatePropagation();

        drawerEl._koraDrawer.open(vid, qty, opt);
      }, true); // capture phase

      _watchButtonText(btn, drawerEl, sectionId);
    });
  }

  function init() {
    initDrawers();
    initFormIntercept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
